<!-- Spacer -->
<div
    class="ioteq-horizontal-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
